import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { Snackbar } from 'daaas-ui';

const Root = styled('div')(() => ({
  '& .MuiSnackbar-root': {
    position: 'static',
  },
}));

const SnackbarNotistack = React.forwardRef((props, ref) => {
  const { closeSnackbar } = useSnackbar();
  const { id, variant, message } = props;

  const handleDismiss = () => {
    closeSnackbar(id);
  };

  return (
    <Root ref={ref}>
      <Snackbar
        open
        message={message}
        severity={variant}
        handleClose={handleDismiss}
      />
    </Root>
  );
});

SnackbarNotistack.propTypes = {
  id: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
};

SnackbarNotistack.displayName = 'SnackbarNotistack';

export default SnackbarNotistack;
